import { UPDATE_BOOKING_SETTINGS } from '../constants';

interface BookingAction {
  type: 'SALON/UPDATE_BOOKING_SETTINGS';
  payload: any;
}

export const defaultState = {};

export function bookingSettingsReducer(state = defaultState, action: BookingAction) {
  switch (action.type) {
    case UPDATE_BOOKING_SETTINGS:
      return { ...(state || {}), ...action.payload };

    default:
      return state;
  }
}
